var _defs, _path, _rect, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSolutions = function SvgSolutions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Solutions_svg__ba6f16a1-eb3a-4646-82e7-3252c14810df{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Solutions_svg__a2436481-4d21-44ec-98fd-70f0efef4c4c",
    "data-name": "Solutions"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Solutions_svg__ba6f16a1-eb3a-4646-82e7-3252c14810df",
    d: "m144.38 132.23-19.32 19.32-.06-.06-.06.06-19.32-19.32A11.55 11.55 0 0 1 122 115.9l3 3.06 3.06-3.06a11.54 11.54 0 0 1 16.32 16.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Solutions_svg__ba6f16a1-eb3a-4646-82e7-3252c14810df",
    x: 47.13,
    y: 71.03,
    width: 155.74,
    height: 107.94,
    rx: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Solutions_svg__ba6f16a1-eb3a-4646-82e7-3252c14810df",
    d: "M47.13 87.92h155.74M97.01 114.06l-17.97 18.26 17.97 17.69M152.99 114.06l17.97 18.26-17.97 17.69"
  }))));
};

export default SvgSolutions;